import httpClient from "./httpClient";
import { AxiosResponse } from "axios";

export class Ping {
  static async ping(): Promise<AxiosResponse> {
    return (await httpClient).get("/ping");
  }
}
